<template>
  <div>
    <navbar back fixed bg>
      <span slot="title">申请借款</span>
    </navbar>
    <div class="page-content">
      <form class="custom-form" @submit.prevent="doAction" novalidate="novalidate">
        <div class="cell-group">
          <div class="input-cells">
            <div class="label-cell">
              <label>借款金额</label>
            </div>
            <div class="input-cell">
              <input type="number" v-model.number="money" class="form-control">
            </div>
            <div class="help-cell">元</div>
          </div>
          <div class="input-cells">
            <div class="label-cell">
              <label>借款期限</label>
            </div>
            <div class="input-cell">
              <input type="number" v-model.number="duration" class="form-control">
            </div>
            <div class="help-cell">天</div>
          </div>
        </div>
        <div class="btn-group">
          <button type="submit" class="btn-submit">提交订单</button>
        </div>
      </form>
    </div>
    <toast :show="toastShow" :text="toastText" @hidden="toastShow=false"></toast>
    <spinner :show="loading"></spinner>
  </div>
</template>

<script>
  import Navbar from 'components/navbar/navbar'
  import Spinner from 'components/spinner/spinner'
  import Toast from 'components/toast/toast'

  export default {
    data () {
      return {
        loading: false,
        toastShow: false,
        toastText: '',
        money: '',
        duration: ''
      }
    },
    components: {
      Navbar,
      Spinner,
      Toast
    },
    created () {
      this.productId = this.$route.params.id
      this.token = this.$cache.getUserToken()
    },
    beforeRouteEnter (to, from, next) {
      next((vm) => {
        if (vm.$cache.getUserToken()) {
          if (to.params.id) {
            next()
          } else {
            next(false)
          }
        } else {
          next('/auth/login')
        }
      })
    },
    methods: {
      doAction () {
        if (this._validate()) {
          let vm = this
          this.loading = true
          this.$ajax({
            url: '/center/addOrder.jhtml',
            params: {
              productId: vm.productId,
              money: vm.money,
              duration: vm.duration,
              uid: vm.token.uid
            },
            done (info, page, res) {
              if (res.data && res.data.info) {
                vm.$dialog({
                  content: res.msg,
                  confirmText: '去完善',
                  onHide () {
                    vm.$router.push('/user/profile/' + res.data.info)
                  }
                })
              } else {
                vm.$dialog({
                  content: res.msg,
                  onHide () {
                    vm.$router.push('/user')
                  }
                })
              }
            },
            fail (msg) {
              vm.$dialog(msg)
            },
            always () {
              vm.loading = false
            }
          })
        }
      },
      _validate () {
        if (!this.money) {
          this.toastText = '请输入借款金额'
          return !(this.toastShow = true)
        }
        if (!this.duration) {
          this.toastText = '请输入借款期限'
          return !(this.toastShow = true)
        }
        return true
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'

  .cell-group
    margin px2rem(20) 0 px2rem(40)
    box-shadow 0 px2rem(10) px2rem(15) rgba(171,185,197, 1)
    .help-cell
      font-size px2rem(24)
      color #275482

  .btn-group
    width 80%
    margin px2rem(60) auto

    .btn-submit
      display block
      width 100%
      height px2rem(80)
      font-size px2rem(32)
      color #fff
      border none
      border-radius px2rem(8)
      background-color #60c9c8
      box-shadow 0 0 px2rem(4) rgba(18,119,163, .75)

</style>



// WEBPACK FOOTER //
// action.vue?54dff689